import React from 'react'
import PropTypes from 'prop-types'
import { map, cond, always, T, prop } from 'ramda'
import strings from 'utils/strings'
import { Button } from 'components/patterns'

const PTO_DIFF_VIEW = 'PTO_DIFF_VIEW'
const NOTES_VIEW = 'NOTES_VIEW'
const TEMPLATE_SELECT_VIEW = 'TEMPLATE_SELECT_VIEW'
const getViewType = cond([
  [prop('isPtoDiffView'), always(PTO_DIFF_VIEW)],
  [prop('isNotesView'), always(NOTES_VIEW)],
  [T, always(TEMPLATE_SELECT_VIEW)],
])

const PtoCreateTemplateActionButtons = ({
  isPtoDiffView,
  isNotesView,
  isGlobalEnabled,
  notes,
  submitting,
  handleDrawerAndClearTemplate,
  handleSetToNotesView,
  handleCancelToTemplateView,
  handleCancelToDiffView,
  handleCreateWithNotes,
}) => {
  const conditions = {
    isPtoDiffView,
    isNotesView,
  }

  const viewType = getViewType(conditions)

  const createTemplateButtons = {
    [TEMPLATE_SELECT_VIEW]: [
      {
        onClick: handleDrawerAndClearTemplate,
        type: 'secondary',
        disabled: false,
        text: strings.cancel,
      },
      {
        type: 'primary',
        disabled: true,
        text: strings.save_pto_template,
      },
    ],
    [PTO_DIFF_VIEW]: [
      {
        onClick: handleCancelToTemplateView,
        type: 'secondary',
        disabled: false,
        text: strings.cancel,
      },
      {
        onClick: handleSetToNotesView,
        type: 'primary',
        disabled: !isGlobalEnabled,
        text: strings.save_pto_template,
      },
    ],
    [NOTES_VIEW]: [
      {
        onClick: handleCancelToDiffView,
        type: 'secondary',
        disabled: submitting,
        text: strings.cancel,
      },
      {
        onClick: handleCreateWithNotes,
        type: 'primary',
        loading: submitting,
        disabled: notes.length === 0,
        text: strings.save_pto_template,
      },
    ],
  }

  const renderButtons = map((buttonProps) => {
    const { text, ...rest } = buttonProps
    return (
      <Button key={text} {...rest}>
        {text}
      </Button>
    )
  })

  return renderButtons(createTemplateButtons[viewType])
}

PtoCreateTemplateActionButtons.propTypes = {
  handleDrawerAndClearTemplate: PropTypes.func,
  handleCancelToTemplateView: PropTypes.func,
  handleSetToNotesView: PropTypes.func,
  handleCancelToDiffView: PropTypes.func,
  handleCreateWithNotes: PropTypes.func,
  isPtoDiffView: PropTypes.bool,
  isNotesView: PropTypes.bool,
  notes: PropTypes.string,
  submitting: PropTypes.bool,
}

export default PtoCreateTemplateActionButtons
